module.exports = __webpack_public_path__ + "static/media/iPhone.594262a9.png";